<template>
  <b-form-group
    :label="label"
    :label-class="{ required }"
    :invalid-feedback="error"
    :state="error ? false : null">
    <string-input-field
      v-bind="$props"
      @input="$emit('input', $event)"
    />
  </b-form-group>
</template>
<script>
import FormFieldMixin from 'vue-forms/mixins/FormFieldMixin';
import StringFieldMixin from 'vue-forms/mixins/StringFieldMixin';

export default {
  mixins: [ FormFieldMixin, StringFieldMixin ],
};
</script>
